import { ApplicationInsights } from '@microsoft/applicationinsights-web';


export default function applicationInsightsLoader() {

    let appInsights;

    window.initApplicationInsights = function (connectionString, userId) {
        appInsights = new ApplicationInsights({
            config: {
                connectionString: connectionString
            }
        });

        appInsights.loadAppInsights();
        appInsights.addTelemetryInitializer(envelope => {
            envelope.data = envelope.data || {};
            envelope.data.userId = userId;
        });
        appInsights.trackPageView();
    };
}